export default __webpack_public_path__ + "static/media/businessImg2.0e7de97f.jpg";